export const Options = {
    Salutation: [
        { text: "Herr", value: "M" },
        { text: "Frau", value: "W" },
        { text: "Divers", value: "D" },
    ],
    AcademicTitle: [
        {text:"Dr.",value:"Dr."},
        {text:"Mag.",value:"Mag."},
        {text:"Prof.",value:"Prof."},
        {text:"Prof. Dr.",value:"Prof. Dr."},
    ]
}
